export const Main = r => require.ensure([], () => r(require('../../Core/components/Main')), 'Records-bundle')

export const Operational = r => require.ensure([], () => r(require('../components/Operational/ListOperational')), 'Operational-bundle')
export const OnboardingManagement = r => require.ensure([], () => r(require('../../Report/components/OnboardingManagement/List')), 'Report-bundle')
export const ActivationManagement = r => require.ensure([], () => r(require('../../Report/components/ActivationManagement/List')), 'Report-bundle')

const children = [

  // Gestão Operacional
  {
    name: 'management.operational.index',
    path: 'operacional',
    component: Operational,
    meta: {
      requiresAuth: true,
      title: 'Gestão Operacional',
      titleMenu: 'Operacional',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Gestão Operacional',
          pathName: ''
        },
      ]
    }
  },
  // Gestão de Onboarding
  {
    name: 'management.onboarding.index',
    path: 'onboarding',
    component: OnboardingManagement,
    meta: {
      requiresAuth: true,
      title: 'Onboarding',
      titleMenu: 'Onboarding',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Onboarding',
          pathName: 'management.onboarding.index'
        },
      ]
    }
  },
  {
    name: 'management.activation.index',
    path: 'activation',
    component: ActivationManagement,
    meta: {
      requiresAuth: true,
      title: 'Ativação',
      titleMenu: 'Ativação',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Ativação',
          pathName: 'management.activation.index'
        },
      ]
    }
  },
]

export default [{
  name: 'management',
  children,
  path: '/gestao',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
